var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.formModule.component,{tag:"component",on:{"hide":_vm.back}})
}
var staticRenderFns = []

export { render, staticRenderFns }